import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface Props {
  vm: JobProgressionViewModel
}
export default observer(function AuthorizationSignedProgressionActions({
  vm,
}: Props) {
  return (
    <>
      <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.viewReturnFiledDocumentCreationModal()}
          dataTest="job-progression-file-return-button"
        >
          Upload Final Documents
        </Button>
      </CardContent>

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
})
